import { axios, Response } from '..'
import { GroupUsers } from './list-group-users'

export default async function deleteGroupUser({
  id
}: {
  id: string
}): Response<GroupUsers[]> {
  return await axios.delete(`/v1/profiles/${id}`)
}
